export  const variantQueryStringName = 'variantid';